<div [class]="theme ? theme : 'one-portal'">
  <div class="">
    <p>
      Before confirming, please verify that you have pulled all frames, cases and packaging to be shipped back using the
      return shipping label and with the RA written on the box.
    </p>
    <p>Once confirmed, you will not be able to make changes to the My Return page for this Refresh.</p>
  </div>
  <div class="button-container btn-group">
    <button mat-button class="btn btn-secondary" (click)="closeDialog(false)">Cancel</button>
    <button mat-button class="btn btn-primary" type="submit" (click)="closeDialog(true)">
      Confirm
    </button>
  </div>
</div>
